import { addThousandSeparator } from "./formatNumber";

export const errorMessage = (errorType: string, paramObj?: any) => {
  switch (errorType) {
    case "invalid-email-address": {
      return "Invalid email address.";
    }
    case "invalid-regex": {
      return `Enter only unaccented letters ${
        paramObj.format
      } for ${paramObj.field.toLowerCase()}.`;
    }
    case "invalid-phone-regex": {
      return `Enter only digits ${
        paramObj.format
      } for ${paramObj.field.toLowerCase()}.`;
    }
    case "invalid-password-regex": {
      return `
Password must contain
- Minimum 8 characters
- One uppercase letter [A-Z]
- One lowercase letter [a-z]
- One number [0-9]
- One special character [ !"#$%&'()*+,-./:;<=>?@[\]^_\`{|}~]`;
    }
    case "dropdown-required-field": {
      return `Please select your ${paramObj.field.toLowerCase()}.`;
    }
    case "required-field": {
      return `Please enter your ${paramObj.field.toLowerCase()}.`;
    }
    case "select-required-field": {
      return `Please select your ${paramObj.field.toLowerCase()}.`;
    }
    case "required-generic": {
      return "Required.";
    }
    case "required-field-block": {
      return `Please complete all the required fields.`;
    }
    case "invalid-format": {
      return `Please enter a valid ${paramObj.field.toLowerCase()}.`;
    }
    case "invalid-format-generic": {
      return `Invaild format.`;
    }
    case "invalid-format-name": {
      return "Enter only unaccented alphabetical letters [A-Z or a-z] and special characters [- , ' / \\\\].";
    }
    case "invalid-format-name-md": {
      return `
Enter only
- Unaccented letters [a-z or A-Z]
- Special characters [- , ' / \\\\\]`;
    }
    case "invalid-value": {
      return `Invaild ${paramObj.field.toLowerCase()}.`;
    }
    case "file-name-too-long": {
      return `File name is longer than ${paramObj.maxNameLength} characters.`;
    }
    case "file-too-large": {
      return `File size is larger than ${paramObj.maxFileSize / 1000000}MB.`;
    }
    case "invalid-file-type-no-param": {
      return `Invalid file type. Only accepts image/jpeg, application/pdf, image/jpg, and image/png.`;
    }
    case "invalid-file-type": {
      let fileTypeStr = "";
      const uniqueFileTypes = paramObj.fileTypes.filter(
        (type: string, index: number) => {
          return paramObj.fileTypes.indexOf(type) === index;
        }
      );
      for (let i = 0; i < uniqueFileTypes.length; i++) {
        if (i > 0) fileTypeStr += ",";
        fileTypeStr += paramObj.fileTypes[i];
      }
      return `${fileTypeStr} ${
        paramObj.fileTypes.length > 1 ? "are" : "is"
      } not an accepted file type${paramObj.fileTypes.length > 1 ? "s." : "."}`;
    }
    case "too-many-files-per-time": {
      return `Please upload a maximum of ${paramObj.maxCountPerTime} documents.`;
    }
    case "too-many-files-total": {
      return `Please upload a maximum of ${paramObj.maxCountTotal} documents.`;
    }
    case "max-length-exceeded": {
      return `The text may not be longer than ${paramObj.limit} characters.`;
    }
    case "character-length-exceeded": {
      return `The ${paramObj.field.toLowerCase()} may not be longer than ${
        paramObj.max
      } characters.`;
    }

    /****************************************
     **************** Currency ***************
     ****************************************/

    case "currency-required":
      return "Please enter the amount you would like to invest.";

    case "token-required":
      return `Please enter the ${paramObj.field?.toLowerCase()}.`;

    case "currency-not-valid-token":
      return `${paramObj.field} must be in digits greater than zero with no decimals.`;

    case "currency-not-valid-market-place":
      return `${paramObj.field} must be in digits greater than zero.`;

    case "currency-negative":
      return `The ${paramObj.field?.toLowerCase()} cannot be negative.`;

    case "currency-too-large":
      return `The ${paramObj.field?.toLowerCase()} may not be larger than ${addThousandSeparator(
        Number(paramObj.max)
      )}.`;

    case "currency-too-small":
      return paramObj.field === "Amount"
        ? "The investment must be greater than or equal to the minimum amount required."
        : `The ${paramObj.field?.toLowerCase()} may not be smaller than ${addThousandSeparator(
            Number(paramObj.min)
          )}.`;

    /****************************************
     ***************** Numbers ***************
     ****************************************/

    case "number-negative":
      return `The ${paramObj.field?.toLowerCase()} cannot be negative.`;

    case "number-too-large":
      return `The ${paramObj.field?.toLowerCase()} may not be larger than ${
        paramObj.max
      }.`;
  }
};
